import NavBar from "../components/navbar";
import Footer from "../components/footer";
import { PaperClipIcon } from "@heroicons/react/solid";
import { FormEvent, useEffect, useState } from "react";
import {
  getUserDetailsApi,
  updateUserDetailsApi,
  uploadProfilePicApi,
} from "../services/user";
import { useAuth } from "../context/authprovider";
import { toast } from "react-toastify";
import { CSRFToken } from "../services/auth";
import { fileTypeFromFile } from "file-type";
import { Scrollbars } from "react-custom-scrollbars-2";

export type Details = {
  username: string;
  givenName: string;
  lastName: string;
  email: string;
  role: string;
  phoneNumber: number;
};

const Profile = () => {
  const { userId } = useAuth();
  const [userDetails, setUserDetails] = useState<Details>();

  const [givenName, setGivenName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [imageFile, setImageFile] = useState<File>();
  const [imagePreview, setImagePreview] = useState("");

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("userId", userId!);
    formData.append("givenName", givenName);
    formData.append("lastName", lastName);
    formData.append("email", email);
    formData.append("phoneNumber", phoneNumber);

    try {
      const response = await updateUserDetailsApi(formData);

      if (response?.status === 200) {
        if (imageFile != null) {
          try {
            if (
              imageFile.type == "image/jpeg" ||
              imageFile!.type == "image/png"
            ) {
              const profilePicFormData = new FormData();
              profilePicFormData.append("userId", userId!);
              profilePicFormData.append("profilePic", imageFile!);
              const profilePicResponse = await uploadProfilePicApi(
                profilePicFormData
              );
              if (
                response?.status === 200 &&
                profilePicResponse?.status === 200
              ) {
                toast.success("Updated profile successfully!");
              }
            } else {
              toast.error("Please upload JPG or PNG file format only");
            }
          } catch (error) {
            toast.error(
              "An error has occured when you tried to upload profile picture"
            );
          }
        } else {
          if (imagePreview != "") {
            toast.success("User profile except Profile Picture has been updated! Please upload JPG or PNG file format only")
          } else {
            toast.success("Updated profile successfully!");
          }
        }
      }
    } catch (error) {
      toast.error(
        "Error updating profile: Email or Phone Number already exist"
      );
    }
  };

  useEffect(() => {
    const loadUserDetails = async () => {
      if (userId != null) {
        const response = await getUserDetailsApi(userId);
        if (response) {
          setUserDetails(response.message);

          setGivenName(response.message.givenName);
          setLastName(response.message.lastName);
          setEmail(response.message.email);
          setPhoneNumber(response.message.phoneNumber);
        } else {
          console.log("Unauthorized Access");
        }
      }
    };
    loadUserDetails();
  }, []);

  const handleChange = (e: any) => {
    if (
      e.target.files[0].type == "image/jpeg" ||
      e.target.files[0].type == "image/png"
    ) {
      setImageFile(e.target.files![0]);
      setImagePreview(URL.createObjectURL(e.target.files![0]));
    } else {
      setImageFile(undefined)
      toast.error("Please upload JPG or PNG file format only");
    }
  };

  return (
    <>
      <NavBar />
      <br></br>
      <div className="mt-36">
        <div>
          <h3 className="text-2xl leading-8 font-large text-gray-900 text-center">
            Update User Profile
          </h3>
        </div>
        <form onSubmit={handleSubmit}>
          <CSRFToken />
          <Scrollbars autoHeight autoHeightMin={100} autoHeightMax="calc(83vh - 36px - 35px - 75px)">
            <div className="mt-5 border-t border-gray-200">
              <dl className="divide-y divide-gray-200">
                <div className="xl:mx-auto h-max bg-white object-center shadow overflow-hidden sm:rounded-md w-5/6" >
                  <div className="py-4 sm:py-5 sm:grid sm:grid-cols-2 sm:gap-4 ">
                    <dt className="text-sm font-medium text-gray-500 text-center">
                      Username
                    </dt>
                    <dd className="mt-1 flex text-sm text-gray-900 sm:mt-0 sm:col-span-1 ">
                      <span className="flex-grow">{userDetails?.username}</span>
                    </dd>
                  </div>
                  <div className="py-4 sm:grid sm:py-5 sm:grid-cols-2 sm:gap-4">
                    <dt className="text-sm font-medium text-gray-500 text-center">
                      First Name
                    </dt>
                    <dd className="mt-1 flex text-sm text-gray-900 sm:mt-0 sm:col-span-1">
                      <span className="flex-grow">
                        <input
                          type="text"
                          name="givenName"
                          defaultValue={userDetails?.givenName}
                          onChange={(e) => setGivenName(e.target.value)}
                          className="appearance-none block w-3/6 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        />
                      </span>
                    </dd>
                  </div>
                  <div className="py-4 sm:grid sm:py-5 sm:grid-cols-2 sm:gap-4">
                    <dt className="text-sm font-medium text-gray-500 text-center">Last Name</dt>
                    <dd className="mt-1 flex text-sm text-gray-900 sm:mt-0 sm:col-span-1">
                      <span className="flex-grow">
                        <input
                          type="text"
                          name="lastName"
                          defaultValue={userDetails?.lastName}
                          onChange={(e) => setLastName(e.target.value)
                          }
                          className="appearance-none block w-3/6 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        />
                      </span>
                    </dd>
                  </div>
                  <div className="py-4 sm:grid sm:py-5 sm:grid-cols-2 sm:gap-4">
                    <dt className="text-sm font-medium text-gray-500 text-center">Email</dt>
                    <dd className="mt-1 flex text-sm text-gray-900 sm:mt-0 sm:col-span-1">
                      <span className="flex-grow">
                        <input
                          type="text"
                          name="email"
                          defaultValue={userDetails?.email}
                          onChange={(e) => setEmail(e.target.value)}
                          className="appearance-none block w-3/6 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        />
                      </span>
                    </dd>
                  </div>
                  <div className="py-4 sm:grid sm:py-5 sm:grid-cols-2 sm:gap-4">
                    <dt className="text-sm font-medium text-gray-500 text-center">Role</dt>
                    <dd className="mt-1 flex text-sm text-gray-900 sm:mt-0 sm:col-span-1">
                      <span className="flex-grow">{userDetails?.role}</span>
                    </dd>
                  </div>
                  <div className="py-4 sm:grid sm:py-5 sm:grid-cols-2 sm:gap-4">
                    <dt className="text-sm font-medium text-gray-500 text-center">
                      Phone Number
                    </dt>
                    <dd className="mt-1 flex text-sm text-gray-900 sm:mt-0 sm:col-span-1">
                      <span className="flex-grow">
                        <input
                          type="text"
                          name="phoneNumber"
                          defaultValue={userDetails?.phoneNumber}
                          onChange={(e) => setPhoneNumber(e.target.value)}
                          className="appearance-none block w-3/6 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        />
                      </span>
                    </dd>
                  </div>
                  <div className="py-4 sm:grid sm:py-5 sm:grid-cols-2 sm:gap-4">
                    <dt className="text-sm font-medium text-gray-500 text-center">
                      Image Upload
                    </dt>
                    <dd className="mt-1 flex text-sm text-gray-900 sm:mt-0 sm:col-span-1">
                      <span className="flex-grow">
                        {imageFile && (
                          <img src={imagePreview} width="100" height="100" />
                        )}
                        <input
                          type="file"
                          id="profilePicUploader"
                          accept="image/*"
                          onChange={(e) => {
                            handleChange(e);
                            // setImageFile(e.target.files![0])
                            // setImagePreview(URL.createObjectURL(e.target.files![0]))
                          }}
                          className="appearance-none block w-3/6 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        />
                      </span>
                    </dd>
                  </div>
                  <button
                    type="submit"
                    className="mx-auto flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                  >
                    Update Profile
                  </button>
                </div>
              </dl>
            </div>
          </Scrollbars>
        </form>
      </div>
      <Footer />
    </>
  );
};

export default Profile;
